import React from 'react';

import {
  SearchResult,
} from '../../../components';

import CourseInfoFull from './Full';
import CourseInfoTeaser from './Teaser';

const Course = ({ entity, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'teaser':
      return (<CourseInfoTeaser entity={entity} {...props} />);
    case 'full':
    default:
      return (<CourseInfoFull entity={entity} {...props} />);

  }
};

export default Course;
